import Vue from 'vue';
import {MLInstaller, MLCreate, MLanguage} from 'vue-multilanguage';

Vue.use(MLInstaller);
import Profile from './helpers/profile';

export default new MLCreate({
  // initial: 'ru',
  initial: Profile.language,
  save: process.env.NODE_ENV === 'production',
  languages: [
    new MLanguage('uk').create({
      welcomeTitle: 'Вітаємо в&nbsp;Нова&nbsp;Пошта',
      welcomeText: 'Ми надаємо послуги легкої доставки для кожного клієнта: оформлюйте просто, працюйте, де зручно, заощаджуйте час.',
      agreement:
        'З <a href="https://novaposhta.ua/uploads/misc/doc/Privacy_policy.pdf" target="_blank">Політикою конфіденційності</a> та з умовами програми «<a href="https://novaposhta.ua/uploads/misc/doc/Loyalty_Program_Terms_bk.pdf" target="_blank">Збільшуй можливості</a>» ознайомлений. Надаю згоду на обробку моїх персональних даних відповідно до Політики конфіденційності.',
      startButtonText: 'Розпочати!',
      welcomeMultiLangText: 'Оберіть мову спілкування',

      next: 'Далі',
      back: 'Назад',
      registration: 'Реєстрація',

      errorPageTitle: 'Щось пішло не так',
      errorPageText404: 'Зазначений адрес не знайдено',
      errorPageButtonStartAgain: 'Почати спочатку',
      errorNetwork: "Перевірте з'єднання з інтернетом",
      errorUnknown: 'Невідома помилка',
      errorRequestTimeout: "Скінчівся час очікування відповіді, перевірте з'єднання з інтернетом",
      errorTooManyAttempts: 'Забагато спроб',
      errorServiceIsBroken: 'Сесія недоступна, спробуйте пройти авторизацію ще раз',
      errorUserNotAllowed: 'Користувач в даний момент недоступний, спробуйте через 20 хвилин',
      errorSecretQuestionNotAllowed: 'Секретне питання не встановлено',
      errorPinCodeNotAllowed: 'Пін-код не встановлено',
      error419CSRF: 'Значенння CSRF не співпадають',
      errorAuthClient: 'Вказані налаштування клієнта авторизації не існують',
      errorOldBrowser: 'Ваша версія браузера застаріла. Будь ласка, оновіть браузер для продовження',

      enterLoginTitle: 'Вкажіть номер телефону або електронну адресу',
      enterLoginErrorPhone: 'Невірно набраний номер. Номер повинен бути у форматі 380XXXXXXXXX',
      enterLoginErrorEmail: 'Невірна електронна адреса',
      enterLoginErrorEmpty: 'Вкажіть номер телефону або електронну адресу',
      enterLoginPinCodeTitle: 'Введіть ваш PIN-код',
      enterLoginPinCodeBottomLink: 'Увійти з секретним запитанням',
      enterLoginHelpText: 'Введіть ваш номер телефону у форматі 380XXXXXXXXX або адресу електронної пошти',
      enterLoginPhoneHelpText: 'Введіть ваш номер телефону у форматі 380XXXXXXXXX',
      faceId: 'Увіти з Face ID',
      sendCodePhone: 'номер',
      sendCodeForRegistrationText: '<p>Цей {0} буде використаний для створення облікового запису.</p><p>Підтвердіть свій {0} за допомогою коду, або змініть його на інший.</p>',

      sendCodeTitleBeforeRegister: 'Схоже на те, що ми ще не знайомі',
      sendCodeTitlePhone: 'Введіть код з СМС',
      sendCodeChangePhone: 'Змінити номер',
      sendCodeTextPhone: 'Підтвердіть свій номер за допомогою коду, який ми надіслали вам на номер: ',
      sendCodeTitleMail: 'Введіть код',
      sendCodeChangeMail: 'Змінити пошту',
      sendCodeTextMail: 'Підтвердіть свій email за допомогою коду, який ми надіслали вам на: ',
      sendCodeEnterCode: 'Ввести код',
      sendCodeErrorWrong: 'Код введено не вірно',

      enterCodeSendAgain: 'Надіслати код повторно',
      enterCodeGetCall: 'Отримати код у зворотному дзвінку',
      enterCodeRepeatThrough: 'Повторити — через',
      enterCodeRepeatCallThrough: 'Очікуйте на дзвінок. Повторити — через ',
      enterCodeSeconds: ' секунд',
      enterCodeValidationEmpty: 'Введіть код',

      secretQuestionTitle: 'Секретне запитання:',
      secretQuestionErrorAnswer: 'Невірна відповідь',
      restoreAccountAccess: 'Відновити доступ до акаунту',

      startRegTitle: 'Ваше повне ім’я',
      startRegButtonNext: 'Заповнити власноруч',
      startRegCheckBankId: 'Звірити з BankID',
      startRegText: "Вкажіть прізвище, ім'я та по батькові. Вони зазначені в офіційному документі, що" + ' засвідчує вашу особу.',
      startRegLater: 'Зареєструватись пізніше',
      startRegLaterText: 'Ви не зможете отримати або відправити посилку',

      cancelRegTitle: 'Ви впевнені що хочете перервати реєстрацію?',
      cancelRegText: 'Заповнені раніше дані будуть видалені і ви не зможете користуватися сервісом',
      cancelRegCancelButton: 'Перервати та видалити',

      setLastNameReg: 'Ваше прізвище',
      setLastNameLableReg: 'Прізвище',
      setFirstNameReg: 'Ваше ім’я',
      setFirstNameLableReg: 'Ім’я',
      setMiddleNameReg: 'Ваше ім’я по батькові',
      setMiddleNameLabelReg: 'По батькові',
      setFioTitleReg: 'Ваше повне ім’я',
      setFioErrorMessage: 'Заповніть поле',
      setFullNameErrorMessage: 'Поля ПІБ заповнено невірно',
      setNameErrorMessage: 'Поле заповнено невірно',

      setBirthdayTitleReg: 'Коли у вас день народження?',
      setBirthdayTextReg: 'За допомогою дати народження ми зможемо вас точніше ідентифікувати та гарантувати безпеку.',
      setBirthdayButtonReg: 'Додати дату',
      setBirthdayButtonRecovery: 'Вибрати дату',
      setBirthdayPlaceholderReg: 'дд/мм/год',
      birthdayError: 'Для користування сервісом ваш вік повинен бути від 14 років',
      errorUserAlreadyExistTitle: 'Нажаль, вказані вами дані вже зареєстровані',
      errorUserAlreadyExistDescr: 'Зверніться, будь ласка, до Центру підтримки клієнтів',
      goToLogin: 'Почати знов',

      setPinCodeTitleReg: 'Створіть PIN-код',
      setPinCodeTextReg: 'Це потрібно, щоб краще захистити ваш аккаунт',
      setPinCodeButtonReg: 'Створити',
      registerPinCodeTitle: 'Створіть PIN-код',
      registerPinCodeRepeatTitle: 'Підтвердіть PIN-код',
      registerAllPinCodeTitle: 'PIN-код для входу',
      registerAllPinCodeHelpText: 'Створіть PIN-код для безпечного входу',
      registerAllPinCodeRepeatHelpText: 'Підтвердіть PIN-код',
      errorRepeatPinCode: 'PIN-код не співпадає',

      setSecretQuestionTitleReg: 'Додайте відповідь на секретне запитання',
      setSecretQuestionTextReg: 'Це потрібно, щоб краще захистити ваш акаунт',
      setSecretQuestionButtonReg: 'Вибрати запитання',
      setSecretQuestionTitle2Reg: 'Додайте відповідь на секретне запитання',
      setSecretQuestionPlaceholderAnswerReg: 'Відповідь',
      setSecretQuestionPlaceholderQuestionReg: 'Секретне запитання',

      setPromptSecretQuestionTitleReg: 'Додайте підказку',
      errorSameTip: 'Підказка та відповідь не можуть співпадати',

      setFinishTitleReg: 'Вітаємо!',
      setFinishTextReg: 'Ви заповнили усі необхідні данні і тепер можете користуватись усіма перевагами нашого сервісу',
      setFinishButtonReg: 'Розпочати!',
      monthNames: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
      shortMonths: ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
      shortDays: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      shortDayNames: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
      ok: 'Ок',
      cancel: 'Скасувати',

      startAccessRecoveryTitle: 'Відновлення доступу',
      startAccessRecoveryText: 'Для відновлення доступу нам необхідно вас ідентифікувати, заповніть усі необхідні дані та відновіть доступ до вашого акаунту.',
      startAccessRecoveryButtonLogin: 'Увійти',

      setPhoneTitle: 'Вкажіть номер телефону',
      setPhoneBottomText: 'Не пам’ятаю номер телефону',
      setEmailTitle: 'Вкажіть електронну адресу',
      setEmailBottomText: "Не пам'ятаю електронної адреси",

      infoSelectLoginTitle: 'Виберіть телефон або електронну адресу для відновлення доступу',
      infoSelectLoginText: 'Ми відправимо код для ідентифікації на вибраний вами номер телефону або електронну адресу.',
      infoSelectLoginHelpText: 'Якщо ви не маєте доступу до запропонованих контактів, зверніться, будь ласка в Центр підтримки клієнтів за телефоном <a href="tel:0800500609" class="tel">0 800 500 609</a>',
      infoSelectLoginButton: 'Вибрати',
      infoSelectLoginErrorTitle: 'На жаль, ми не знайшли ваших контактних даних для відновлення доступу',
      infoSelectLoginErrorText: 'Зверніться, будь ласка, в Центр підтримки клієнтів, або зареєструйтесь',

      accessRecoveryFinishText: 'Доступ до вашого акаунту відновлено, тепер ви можете ввійти.',
      errorUserAlreadyExist: 'Такий користувач вже існує',
      accessRecoveryChangePhone: 'Авторизуватися з іншим номером',
      accessRecoveryChangeEmail: 'Авторизуватися з іншою поштою',

      addEmailTitle: 'Вкажіть за необхідністю електронну адресу',
      addPhoneTitle: 'Вкажіть номер телефону',
      addEmailLater: 'Додати адресу пізніше',

      setAdditionalParamsTitle: 'Будь ласка, налаштуйте додаткові параметри безпеки',
      setAdditionalParamsText: 'З метою безпечної ідентифікації нам необхідна інформація про вас',
      additionalParamsNextButton: 'Налаштувати параметри',
      additionalParamsCancelButton: 'Перервати',

      outApiTitle1: 'Надавши доступ сайту ',
      outApiTitle2: ' до вашого акаунту Нової пошти, ви зможете:',
      outApiText: [
        `Створювати накладні на доставку із замовлень`,
        `Керувати цими накладними (редагування, видалення та ін)`,
        `Замовляти додаткові послуги та сервіси`,
        `Відслідковувати місцезнаходження посилки`,
        `Використовувати інші можливості <a href="https://devcenter.novaposhta.ua/docs/services/" target="_blank">публічного АПІ Нової пошти.</a>`,
      ],
      outApiHelp: ' отримає доступ до конфіденційної інформації. Якщо довіряєте сервісу, тисніть зелену кнопку.',
      outApiRemember: 'Запам’ятати вибір',
      outApiBtnAccept: 'Підтвердити',
      outApiBtnReject: 'Відмовити',
    }),

    new MLanguage('ru').create({
      welcomeTitle: 'Приветствуем в&nbsp;Нова&nbsp;Пошта',
      welcomeText: 'Мы предоставляем услуги легкой доставки для каждого клиента: оформляйте просто, работайте, где удобно, экономьте время.',
      startButtonText: 'Начать!',
      welcomeMultiLangText: 'Выберите язык общения',
      agreement:
        'С <a href="https://novaposhta.ua/uploads/misc/doc/Privacy_policy.pdf" target="_blank">Политикой конфиденциальности</a> и с условиями программы «<a href="https://novaposhta.ua/uploads/misc/doc/Loyalty_Program_Terms_bk.pdf" target="_blank">Збільшуй можливості</a>» ознакомлен. Предоставляю согласие на обработку моих персональных данных в соответствии с Политикой конфиденциальности.',

      next: 'Далее',
      back: 'Назад',
      registration: 'Регистрация',

      errorPageTitle: 'Что-то пошло не так',
      errorPageText404: 'Указанный адрес не найден',
      errorPageButtonStartAgain: 'Начать сначала',
      errorNetwork: 'Проверьте соединение с интернетом',
      errorUnknown: 'Неизвестная ошибка',
      errorRequestTimeout: 'Закончилось время ожидания ответа, проверьте соединение с интенетом',
      errorTooManyAttempts: 'Слишком много попыток',
      errorServiceIsBroken: 'Сессия недоступна, попробуйте пройти авторизацию еще раз',
      errorUserNotAllowed: 'Пользователь сейчас недоступен, попробуйте через 20 минут',
      errorSecretQuestionNotAllowed: 'Секретный вопрос не установлен',
      errorPinCodeNotAllowed: 'Пин-код не установлен',
      error419CSRF: 'Значенння CSRF не совпадают',
      errorAuthClient: 'Указанные настройки клиента авторизации не существуют',
      errorOldBrowser: 'Ваша версия браузера устарела. Обновите свой браузер, чтобы продолжить',

      enterLoginTitle: 'Укажите номер телефона или адрес электронной почты',
      enterLoginErrorPhone: 'Неверно набранный номер. Номер должен быть в формате 380XXXXXXXXX',
      enterLoginErrorEmail: 'Неверный адрес электронной почты',
      enterLoginErrorEmpty: 'Укажите номер телефона или адрес электронной почты',
      enterLoginPinCodeTitle: 'Укажите ваш PIN-код',
      enterLoginPinCodeBottomLink: 'Войти с секретним вопросом',
      enterLoginHelpText: 'Введите ваш номер телефона в формате 380XXXXXXXXX или адрес электронной почты',
      enterLoginPhoneHelpText: 'Введите ваш номер телефона в формате 380XXXXXXXXX',
      faceId: 'Войти с Face ID',
      sendCodePhone: 'номер',
      sendCodeForRegistrationText: '<p>Этот {0} будет использован для создания учетной записи.</p><p>Подтвердите свой {0} с помощью кода, или измените его на другой.</p>',

      sendCodeTitleBeforeRegister: 'Похоже на то, что мы еще не знакомы',
      sendCodeTitlePhone: 'Введите код из СМС',
      sendCodeChangePhone: 'Изменить номер',
      sendCodeTextPhone: 'Подтвердите свой номер с помощью кода, который мы отправили вам на номер: ',
      sendCodeTitleMail: 'Введите код',
      sendCodeChangeMail: 'Изменить почту',
      sendCodeTextMail: 'Подтвердите свой email с помощью кода, который мы отправили вам на: ',
      sendCodeEnterCode: 'Ввести код',
      sendCodeErrorWrong: 'Код введен неверно',

      enterCodeSendAgain: 'Отправить код повторно',
      enterCodeGetCall: 'Получить код в обратном звонке',
      enterCodeRepeatThrough: 'Повторить - через ',
      enterCodeRepeatCallThrough: 'Ожидайте звонок. Повторить - через ',
      enterCodeSeconds: ' секунд',
      enterCodeValidationEmpty: 'Введите код',

      secretQuestionTitle: 'Секретный вопрос:',
      secretQuestionErrorAnswer: 'Неверный ответ',
      restoreAccountAccess: 'Восстановить доступ к аккаунту',

      startRegTitle: 'Ваше полное имя',
      startRegButtonNext: 'Заполнить собственноручно',
      startRegCheckBankId: 'Сверить с BankID',
      startRegText: 'Укажите фамилию, имя и отчество. Они указаны в официальном документе, удостоверяющем вашу' + ' личность.',
      startRegLater: 'Зарегистрироваться позже',
      startRegLaterText: 'Вы не сможете получить или отправить посылку',

      cancelRegTitle: 'Вы уверены, что хотите прервать регистрацию?',
      cancelRegText: 'Заполненные ранее данные будут удалены, и вы не сможете пользоваться сервисом.',
      cancelRegCancelButton: 'Прервать и удалить',

      setLastNameReg: 'Ваша фамилия',
      setLastNameLableReg: 'Фамилия',
      setFirstNameReg: 'Ваше имя',
      setFirstNameLableReg: 'Имя',
      setMiddleNameReg: 'Ваше отчество',
      setMiddleNameLabelReg: 'Отчество',
      setFioTitleReg: 'Ваше полное имя',
      setFioErrorMessage: 'Заполните поле',
      setFullNameErrorMessage: 'Поля ФИО заполнено неправильно',
      setNameErrorMessage: 'Поле заполнено неправильно',

      setBirthdayTitleReg: 'Когда у вас день рождения?',
      setBirthdayTextReg: 'С помощью даты рождения мы сможем вас точно идентифицировать и обеспечить безопасность.',
      setBirthdayButtonReg: 'Добавить дату',
      setBirthdayButtonRecovery: 'Выбрать дату',
      setBirthdayPlaceholderReg: 'дд/мм/год',
      birthdayError: 'Для пользования сервисом ваш возвраст должен быть от 14 лет',
      errorUserAlreadyExistTitle: 'К сожалению, указанные вами данные уже зарегистрированы',
      errorUserAlreadyExistDescr: 'Обратитесь, пожалуйста, в Центр поддержки клиентов',
      goToLogin: 'Начать снова',

      setPinCodeTitleReg: 'Создайте PIN-код',
      setPinCodeTextReg: 'Это необходимо, чтобы лучше защитить ваш аккаунт',
      setPinCodeButtonReg: 'Создать',
      registerPinCodeTitle: 'Создайте PIN-код',
      registerPinCodeRepeatTitle: 'Подтвердите PIN-код',
      registerAllPinCodeTitle: 'PIN-код для входа',
      registerAllPinCodeHelpText: 'Создайте PIN-код для безопасного входа',
      registerAllPinCodeRepeatHelpText: 'Подтвердите PIN-код',
      errorRepeatPinCode: 'PIN-код не совпадает',

      setSecretQuestionTitleReg: 'Добавьте ответ на секретный вопрос',
      setSecretQuestionTextReg: 'Это нужно, чтобы лучше защитить ваш аккаунт.',
      setSecretQuestionButtonReg: 'Выбрать вопрос',
      setSecretQuestionTitle2Reg: 'Добавьте ответ на секретный вопрос',
      setSecretQuestionPlaceholderAnswerReg: 'Ответ',
      setSecretQuestionPlaceholderQuestionReg: 'Секретный вопрос',

      setPromptSecretQuestionTitleReg: 'Добавьте подсказку',
      errorSameTip: 'Подсказка и ответ не могут совпадать',

      setFinishTitleReg: 'Поздравляем!',
      setFinishTextReg: 'Вы заполнили все необходимые данные и теперь можете пользоваться всеми преимущества нашего сервиса.',
      setFinishButtonReg: 'Начать!',
      monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      shortMonths: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
      shortDays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      shortDayNames: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
      ok: 'Ок',
      cancel: 'Отменить',

      startAccessRecoveryTitle: 'Восстановление доступа',
      startAccessRecoveryText: 'Для восстановления доступа нам необходимо вас идентифицировать, заполните все необходимые данные и восстановите доступ к вашему аккаунту.',
      startAccessRecoveryButton: 'Начать!',
      startAccessRecoveryButtonLogin: 'Войти',

      setPhoneTitle: 'Укажите номер телефона ',
      setPhoneBottomText: 'Не помню номер телефона',
      setEmailTitle: 'Укажите  адрес электронной почти',
      setEmailBottomText: 'Не помню адрес электронной почты',

      infoSelectLoginTitle: 'Выберите телефон или адрес электронной почты для восстановления доступа',
      infoSelectLoginText: 'Мы отправим код для идентификации на выбранный вами номер телефона или адрес электронной почты.',
      infoSelectLoginHelpText: 'Если у вас нет доступа к предложенным контактам, обратитесь в Центр поддержки клиентов по телефону <a href="tel:0800500609" class="tel">0 800 500 609</a>',
      infoSelectLoginButton: 'Выбрать',
      infoSelectLoginErrorTitle: 'К сожалению, мы не нашли ваших контактных данных для восстановления доступа',
      infoSelectLoginErrorText: 'Обратитесь, пожалуйста, в Центр поддержки клиентов или зарегистрируйтесь',

      accessRecoveryFinishText: 'Доступ к вашему аккаунту возобновлен, теперь вы можете войти',
      errorUserAlreadyExist: 'Такой пользователь уже существует',
      accessRecoveryChangePhone: 'Авторизоваться с другим номером',
      accessRecoveryChangeEmail: 'Авторизоваться с другой почтой',

      addEmailTitle: 'Укажите при необходимости электронный адрес',
      addPhoneTitle: 'Укажите номер телефона',
      addEmailLater: 'Добавить адрес позже',

      setAdditionalParamsTitle: 'Пожалуйста, установите дополнительные параметры безопасности',
      setAdditionalParamsText: 'С целью безопасной идентификации нам необходима информация о вас',
      additionalParamsNextButton: 'Настроить параметры',
      additionalParamsCancelButton: 'Прервать',

      outApiTitle1: 'Предоставив доступ сайту ',
      outApiTitle2: ' к вашему аккаунту Новой почты, вы сможете:',
      outApiText: [
        `Создавать накладные на доставку из заказов`,
        `Управлять этими накладными (редактирование, удаление и т.д.)`,
        `Заказывать дополнительные услуги и сервисы`,
        `Отслеживать местонахождение посылки`,
        `Использовать другие возможности <a href="https://devcenter.novaposhta.ua/docs/services/" target="_blank">публичного АПИ Новой почты.</a>`,
      ],
      outApiHelp: ' отримає доступ до конфіденційної інформації. Якщо довіряєте сервісу, тисніть зелену кнопку.',
      outApiRemember: 'Запомнить выбор',
      outApiBtnAccept: 'Подтвердить',
      outApiBtnReject: 'Отказать',
    }),

    new MLanguage('en').create({
      welcomeTitle: 'Welcome to&nbsp;Nova&nbsp;Poshta',
      welcomeText: 'We provide easy delivery services for every customer: order quickly, work conveniently, and save your time.',
      startButtonText: 'Get started!',
      welcomeMultiLangText: 'Choose a language',
      agreement:
        'Familiar with the <a href="https://novaposhta.ua/uploads/misc/doc/Privacy_policy.pdf" target="_blank">Privacy Policy</a> and the terms of the program «<a href="https://novaposhta.ua/uploads/misc/doc/Loyalty_Program_Terms_bk.pdf" target="_blank">Zbilʹshuy mozhlyvosti</a>». I consent to the processing of my personal data in accordance with the Privacy Policy.',
      next: 'Next',
      back: 'Back',
      registration: 'Register',

      errorPageTitle: 'Something went wrong',
      errorPageText404: 'The specified address was not found',
      errorPageButtonStartAgain: 'Start over',
      errorNetwork: 'Check internet connection',
      errorUnknown: 'Unknown error',
      errorRequestTimeout: 'The response timeout has expired, check your internet connection',
      errorTooManyAttempts: 'Too many attempts',
      errorServiceIsBroken: 'Session is unavailable, please try to log in again',
      errorUserNotAllowed: 'User is currently unavailable, try after 20 minutes',
      errorSecretQuestionNotAllowed: 'A secret question has not been set up',
      errorPinCodeNotAllowed: 'A PIN has not been set up',
      error419CSRF: 'CSRF values do not match',
      errorAuthClient: 'The specified authorization client settings do not exist',
      errorOldBrowser: 'Your browser version is out of date. Please update your browser to continue',

      enterLoginTitle: 'Enter phone number or email',
      enterLoginErrorPhone: 'Invalid number. The number must be in the format 380XXXXXXXXX',
      enterLoginErrorEmail: 'Invalid email address',
      enterLoginErrorEmpty: 'Enter phone number or email address',
      enterLoginPinCodeTitle: 'Enter PIN-code',
      enterLoginPinCodeBottomLink: 'Enter with secret question',
      enterLoginHelpText: 'Enter your phone number in the international format 380XXXXXXXXX or email address',
      enterLoginPhoneHelpText: 'Enter your phone number in the international format 380XXXXXXXXX',
      faceId: 'Log in with Face ID',
      sendCodePhone: 'number',
      sendCodeForRegistrationText: '<p>This {0} will be used to create the account.</p><p>Confirm your {0} with a code, or change it to another.</p>',

      sendCodeTitleBeforeRegister: "It looks like we don't know each other yet",
      sendCodeTitlePhone: 'Enter SMS сode',
      sendCodeChangePhone: 'Change number',
      sendCodeTextPhone: 'Confirm your number with the code we sent you to: ',
      sendCodeTitleMail: 'Enter сode',
      sendCodeChangeMail: 'Change email',
      sendCodeTextMail: 'Confirm your email with the code we sent you to: ',
      sendCodeEnterCode: 'Enter code',
      sendCodeErrorWrong: 'The code you entered is invalid',

      enterCodeSendAgain: 'Resend code',
      enterCodeGetCall: 'Get a code in a сallback',
      enterCodeRepeatThrough: 'Repeat - after ',
      enterCodeRepeatCallThrough: 'Wait for a call. Repeat - after ',
      enterCodeSeconds: ' seconds',
      enterCodeValidationEmpty: 'Enter сode',

      secretQuestionTitle: 'Security question:',
      secretQuestionErrorAnswer: 'Wrong answer',
      restoreAccountAccess: 'Recover account access',

      startRegTitle: 'Your full name',
      startRegButtonNext: 'Fill in manually ',
      startRegCheckBankId: 'Check with BankID',
      startRegText: 'Please indicate your name and surname. They are listed in an official ID document.',
      startRegLater: 'Register later',
      startRegLaterText: 'You will not be able to receive or send a parcel',

      cancelRegTitle: 'Are you sure you want to cancel the registration?',
      cancelRegText: 'The previously filled information will be deleted and you will not be able to use the service.',
      cancelRegCancelButton: 'Cancel and delete',

      setLastNameReg: 'Your surname',
      setLastNameLableReg: 'Surname',
      setFirstNameReg: 'Your first name',
      setFirstNameLableReg: 'First name',
      setMiddleNameReg: 'Your patronymic',
      setMiddleNameLabelReg: 'Patronymic',
      setFioTitleReg: 'Your full name', //?
      setFioErrorMessage: 'The field is empty',
      setFullNameErrorMessage: "Fullname's fields filled incorrectly",
      setNameErrorMessage: 'The field filled incorrectly',

      setBirthdayTitleReg: 'When is your birthday?',
      setBirthdayTextReg: 'With the date of birth, we can accurately verify your identity and ensure safety.',
      setBirthdayButtonReg: 'Add date',
      setBirthdayButtonRecovery: 'Select date',
      setBirthdayPlaceholderReg: 'dd/mm/yyyy',
      birthdayError: 'You must be from 14 years old to use the service',
      errorUserAlreadyExistTitle: 'Sorry, the data you provided is already registered',
      errorUserAlreadyExistDescr: 'Please contact the Customer Support Center',
      goToLogin: 'Start again',

      setPinCodeTitleReg: 'Create a PIN',
      setPinCodeTextReg: 'It is needed to better protect your account.',
      setPinCodeButtonReg: 'Create',
      registerPinCodeTitle: 'Create a PIN',
      registerPinCodeRepeatTitle: 'Confirm a PIN',
      registerAllPinCodeTitle: 'PIN for login',
      registerAllPinCodeHelpText: 'Create a PIN for secure login',
      registerAllPinCodeRepeatHelpText: 'Confirm a PIN',
      errorRepeatPinCode: 'PIN does not match',

      setSecretQuestionTitleReg: 'Add an answer to your security question',
      setSecretQuestionTextReg: 'It is needed to better protect your account.',
      setSecretQuestionButtonReg: 'Choose question',
      setSecretQuestionTitle2Reg: 'Add an answer to your security question',
      setSecretQuestionPlaceholderAnswerReg: 'Answer',
      setSecretQuestionPlaceholderQuestionReg: 'Security question',

      setPromptSecretQuestionTitleReg: 'Add hint',
      errorSameTip: 'Hint and answer can not be the same',

      setFinishTitleReg: 'Congratulations!',
      setFinishTextReg: 'You have filled in all necessary information and now you can enjoy the benefits of our service.',
      setFinishButtonReg: 'Get started!',

      monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      shortDayNames: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      ok: 'Ok',
      cancel: 'Cancel',

      startAccessRecoveryTitle: 'Access recovery',
      startAccessRecoveryText: 'To reсover access, we need to verify your identity. Fill in all necessary data and recover access to your account.',
      startAccessRecoveryButton: 'Get started!',
      startAccessRecoveryButtonLogin: 'Log in',

      setPhoneTitle: 'Enter phone number',
      setPhoneBottomText: "I don't remember the phone number",
      setEmailTitle: 'Enter email address',
      setEmailBottomText: "I don't remember the email address",

      infoSelectLoginTitle: 'Choose phone or email to recover access',
      infoSelectLoginText: 'We will send a verification code to phone number or email address you have chosen.',
      infoSelectLoginHelpText: 'If you do not have access to the suggested contacts, please contact the Customer Support Center by phone <a href="tel:0800500609" class="tel">0 800 500 609</a>',
      infoSelectLoginButton: 'Choose',
      infoSelectLoginErrorTitle: 'Sorry, we could not find your contact information to restore access',
      infoSelectLoginErrorText: 'Please contact the Customer Support Center or register',

      accessRecoveryFinishText: 'Your account access has been recovered, you can now log in.',
      errorUserAlreadyExist: 'User already exist',
      accessRecoveryChangePhone: 'Log in with another number',
      accessRecoveryChangeEmail: 'Log in with another email',

      addEmailTitle: 'Please provide an email address if required',
      addPhoneTitle: 'Enter a phone number',
      addEmailLater: 'Add an email address later',

      setAdditionalParamsTitle: 'Please configure additional security settings',
      setAdditionalParamsText: 'We need information about you for secure identification',
      additionalParamsNextButton: 'Adjust settings',
      additionalParamsCancelButton: 'Cancel',

      outApiTitle1: 'Providing ',
      outApiTitle2: ' access to your Nova poshta account, you get the following benefits:',
      outApiText: [
        `Quick creation of waybills from orders`,
        `Waybill management (editing, deletion, etc.)`,
        `Access to additional services`,
        `Parcel tracking`,
        `Other <a href="https://devcenter.novaposhta.ua/docs/services/" target="_blank">Nova poshta public API</a> features.`,
      ],
      outApiHelp: ' отримає доступ до конфіденційної інформації. Якщо довіряєте сервісу, тисніть зелену кнопку.',
      outApiRemember: 'Remember my choice',
      outApiBtnAccept: 'Confirm',
      outApiBtnReject: 'Cancel',
    }),
  ],
});
